import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint import/order: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { VIEW_TYPE, DEFAULT_AVATAR_SIZE } from '../../../constants/note.general';

// Components
import Avatar from '../../../../../atoms/Avatar';
import UserInfo from '../../../../UserInfo';
import TimeStamp from '../../../TimeStamp';
import ActionButtons from '../../../ActionButtons';
import NoteDisplay from '../../../NoteEditor/NoteDisplay';
import styles from './noteView.module.scss';
var NoteView = /*#__PURE__*/function (_Component) {
  _inherits(NoteView, _Component);
  var _super = _createSuper(NoteView);
  function NoteView() {
    var _this;
    _classCallCheck(this, NoteView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderAvatar", function () {
      var _this$props = _this.props,
        userImage = _this$props.userImage,
        userName = _this$props.userName;
      return /*#__PURE__*/React.createElement(Avatar, {
        containerClassName: styles.avatar,
        size: DEFAULT_AVATAR_SIZE,
        image: userImage,
        name: userName,
        displayName: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderNoteContent", function () {
      var _this$props2 = _this.props,
        noteDate = _this$props2.noteDate,
        noteText = _this$props2.noteText,
        isNoteEdited = _this$props2.isNoteEdited,
        userName = _this$props2.userName,
        userRole = _this$props2.userRole,
        associatedUsers = _this$props2.associatedUsers,
        enableMentions = _this$props2.enableMentions;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.noteContent
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex align-items-start ".concat(styles.noteInfo)
      }, /*#__PURE__*/React.createElement(UserInfo, {
        userName: userName,
        userRole: userRole
      }), /*#__PURE__*/React.createElement(TimeStamp, {
        view: VIEW_TYPE.DEFAULT,
        date: noteDate
      })), /*#__PURE__*/React.createElement(NoteDisplay, {
        note: noteText,
        isEdited: isNoteEdited,
        enableMentions: enableMentions,
        associatedUsers: associatedUsers
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderNoteActions", function () {
      var noteActions = _this.props.noteActions;
      return /*#__PURE__*/React.createElement(ActionButtons, {
        className: styles.noteActions,
        actions: noteActions,
        placement: "bottomRight"
      });
    });
    return _this;
  }
  _createClass(NoteView, [{
    key: "render",
    value: function render() {
      var hideActions = this.props.hideActions;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.noteView
      }, this.renderAvatar(), this.renderNoteContent(), !hideActions && this.renderNoteActions());
    }
  }]);
  return NoteView;
}(Component);
NoteView.propTypes = {
  userImage: PropTypes.string,
  userName: PropTypes.string.isRequired,
  userRole: PropTypes.string,
  noteDate: PropTypes.string,
  hideActions: PropTypes.bool,
  noteActions: PropTypes.array,
  noteText: PropTypes.string,
  isNoteEdited: PropTypes.bool,
  associatedUsers: PropTypes.object,
  enableMentions: PropTypes.bool
};
NoteView.defaultProps = {
  userImage: '',
  userRole: '',
  noteDate: undefined,
  hideActions: false,
  noteActions: EMPTY_ARRAY,
  noteText: '',
  isNoteEdited: false,
  associatedUsers: EMPTY_OBJECT,
  enableMentions: false
};
export default NoteView;